<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  .label-text {
    display: flex;
    flex-direction: row;
    gap: 6px;
    padding: 0 utils.in_rem(4px) utils.in_rem(4px) utils.in_rem(4px);

    &.large {
      @include mixins.body2();
    }

    &.small {
      @include mixins.body3-tooltip-and-caption();
    }
  }
</style>

<script>
  import IconScale from "../IconScale.svelte";

  export let label = "";
  export let labelSize = "small";
  export let tooltipMessage = ""; // Appears when hovering over the info icon
  export let style = "";
</script>

<!-- This text optionally appears above the input field -->
<div class="label-text {labelSize}" {style}>
  <span>{label}</span>
  {#if tooltipMessage}
    <IconScale class="fa-circle-info" size="xs" placement="top">
      <span slot="tooltip">{tooltipMessage}</span>
    </IconScale>
  {/if}
</div>
